export enum CooperationSettlementRequestStatusEnum {
  Pending = 1,
  InProgress = 2,
  Done = 3,
  Rejected = 4
}
